import React, { useEffect } from 'react'
import './notify.scss';
import { Link ,useLocation} from 'react-router-dom';
import { SectionWrapper } from '../../../theme/layouts/MainLayout';
import { bgYellow } from '../../utils/constant';
import { scrollToTop } from '../../utils';
import { useAppContext } from '../../context';

function Notification() {
    const location = useLocation();
    const {pathname} = location;
    const { notification, setNotification } = useAppContext();
  
    const handleToggle = () => {
        setNotification(false);
      };
    
    useEffect(() => {
        scrollToTop(); 
        return () => scrollToTop()
    }, [pathname]);
    
    return (
        <>
        {notification && <SectionWrapper bg={bgYellow} >
            <div id='notify-box' className='w-100 notification-container'>

                <div className="notification-content">
                    <div className='notification-title'>See what's next from Best Buy Ads.</div>  
                    <div className='notification-link'><Link className='cta-read-more' to="/innovations-and-partnerships">Learn More</Link></div> 
                </div>
                <div className="notify-cta" onClick={() => {
                    handleToggle();
                }}>
                    <i className="bi bi-x" id="closed"></i>
                </div>

            </div>
        </SectionWrapper>}
        </>
    )
}

export default Notification